(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8967],{

/***/ 5320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ header_Index; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./src/components/header/styles/styles.module.scss
var styles_module = __webpack_require__(2390);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/react-icons/ci/index.mjs
var ci = __webpack_require__(6454);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.mjs
var md = __webpack_require__(80);
// EXTERNAL MODULE: ./src/helpers/functions.js
var functions = __webpack_require__(6675);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/header/MobileMenu.jsx











const MobileMenu = _ref => {
  let {
    showSidebar,
    setShowSidebar
  } = _ref;
  const {
    asPath,
    locale
  } = (0,router.useRouter)();
  const {
    settings
  } = (0,es/* useSelector */.v9)(state => state.settings);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: showSidebar ? "mobile-menu active" : "mobile-menu",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "menu-top d-flex align-items-center justify-content-between gap-3",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "logo",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          prefetch: false,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: locale === "ar" ? (0,functions/* handleImageLink */.Iz)(settings === null || settings === void 0 ? void 0 : settings.appLogo) : (0,functions/* handleImageLink */.Iz)(settings === null || settings === void 0 ? void 0 : settings.appLogoEn),
              width: 140,
              height: 50,
              alt: "Logo",
              title: (settings === null || settings === void 0 ? void 0 : settings.appName) || ""
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        type: "button",
        onClick: () => setShowSidebar(false),
        "aria-label": "Close Menu",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(md/* MdClose */.FU5, {
          color: "#fff",
          size: 30
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "menu-bottom",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            prefetch: false,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: asPath === "/" ? "active" : "",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "home"
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/about",
            prefetch: false,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: asPath === "/about" ? "active" : "",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "about-us"
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/services",
            prefetch: false,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: asPath.includes("services") ? "active" : "",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "services"
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/projects",
            prefetch: false,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: asPath.includes("projects") ? "active" : "",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "projects"
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/blog",
            prefetch: false,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: asPath.includes("blog") ? "active" : "",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "blog"
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/faqs",
            prefetch: false,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: asPath === "/faqs" ? "active" : "",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "faqs"
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/contact",
            prefetch: false,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: asPath === "/contact" ? "active" : "",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "request"
              })
            })
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var header_MobileMenu = (MobileMenu);
;// CONCATENATED MODULE: ./src/components/header/Index.jsx














const Index = _ref => {
  let {
    innerPages,
    landing,
    thanksHeader
  } = _ref;
  const {
    asPath,
    locale,
    pathname,
    query
  } = (0,router.useRouter)();
  const {
    0: showSidebar,
    1: setShowSidebar
  } = (0,react.useState)(false);
  const {
    settings,
    singleBlog,
    singleCategory
  } = (0,es/* useSelector */.v9)(state => state.settings);
  const targetLocale = locale === "en" ? "ar" : "en";
  const localizedPath = (0,react.useMemo)(() => {
    const cleanPath = (asPath || "/").split("?")[0].split("#")[0] || "/";

    if (pathname === "/blog/[slug]") {
      var _singleBlog$slug;

      const blogSlug = singleBlog === null || singleBlog === void 0 ? void 0 : (_singleBlog$slug = singleBlog.slug) === null || _singleBlog$slug === void 0 ? void 0 : _singleBlog$slug[targetLocale];

      if (typeof blogSlug === "string" && blogSlug.length > 0) {
        return `/blog/${blogSlug}`;
      }

      if (typeof (query === null || query === void 0 ? void 0 : query.slug) === "string" && query.slug.length > 0) {
        return `/blog/${query.slug}`;
      }

      return "/blog";
    }

    if (pathname === "/blog/categories/[slug]") {
      var _singleCategory$slug;

      const categorySlug = singleCategory === null || singleCategory === void 0 ? void 0 : (_singleCategory$slug = singleCategory.slug) === null || _singleCategory$slug === void 0 ? void 0 : _singleCategory$slug[targetLocale];

      if (typeof categorySlug === "string" && categorySlug.length > 0) {
        return `/blog/categories/${categorySlug}`;
      }

      if (typeof (query === null || query === void 0 ? void 0 : query.slug) === "string" && query.slug.length > 0) {
        return `/blog/categories/${query.slug}`;
      }

      return "/blog/categories";
    }

    if (cleanPath.includes("[slug]") || cleanPath.includes("%5Bslug%5D")) {
      return "/blog";
    }

    return cleanPath;
  }, [asPath, pathname, query === null || query === void 0 ? void 0 : query.slug, singleBlog, singleCategory, targetLocale]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: landing ? `${(styles_module_default())["header-section"]} ${(styles_module_default())["landing-page"]}` : thanksHeader ? `${(styles_module_default())["header-section"]} ${(styles_module_default())["thanks-page"]}` : `${(styles_module_default())["header-section"]}`,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Container["default"], {
      className: "d-flex align-items-center gap-3 justify-content-between",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "logo",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          prefetch: false,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: locale === "ar" ? (0,functions/* handleImageLink */.Iz)(settings === null || settings === void 0 ? void 0 : settings.appLogo) : (0,functions/* handleImageLink */.Iz)(settings === null || settings === void 0 ? void 0 : settings.appLogoEn),
              width: 140,
              height: 50,
              alt: "Logo",
              title: (settings === null || settings === void 0 ? void 0 : settings.appName) || ""
            })
          })
        })
      }), !landing && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "menu",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          className: "d-flex align-items-center gap-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/",
              prefetch: false,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: asPath === "/" ? "active" : "",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "home"
                })
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/about",
              prefetch: false,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: asPath === "/about" ? "active" : "",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "about-us"
                })
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/services",
              prefetch: false,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: asPath.includes("services") ? "active" : "",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "services"
                })
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/projects",
              prefetch: false,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: asPath.includes("projects") ? "active" : "",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "projects"
                })
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/blog",
              prefetch: false,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: asPath.includes("blog") ? "active" : "",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "blog"
                })
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/faqs",
              prefetch: false,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: asPath === "/faqs" ? "active" : "",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "faqs"
                })
              })
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "actions d-flex align-items-center gap-3",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: localizedPath,
          locale: targetLocale,
          passHref: true,
          prefetch: false,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "lang",
            children: locale === "en" ? "AR" : "EN"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/contact",
          prefetch: false,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: `btn ${innerPages ? "inner-btn" : ""}`,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "request"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          className: "menu-btn d-lg-none",
          "aria-label": "Toggle Menu",
          onClick: () => setShowSidebar(true),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ci/* CiMenuFries */.F3G, {
            size: 30,
            color: "#fff"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(header_MobileMenu, {
      showSidebar: showSidebar,
      setShowSidebar: setShowSidebar
    })]
  });
};

/* harmony default export */ var header_Index = (Index);

/***/ }),

/***/ 2390:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header-section":"styles_header-section__vkSgY","landing-page":"styles_landing-page__eh_2Y","thanks-page":"styles_thanks-page__uGiRW"};

/***/ })

}]);